// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { useEffect, useState } from 'react';
import { PortfolioProjectEntry, ProjectCardsContainerProps } from './ProjectCards.types';
import ProjectCards from './ProjectCards';
import { Contentful } from '@brr-dev/contentful';
import { ContentfulAPI } from '../../../api/ContentfulAPI';

export default function ProjectCardsContainer(_props: ProjectCardsContainerProps) {
    // TODO do all of this stuff in an atomic state store
    const [projects, setProjects] = useState<PortfolioProjectEntry[]>();
    const [assets] = useState<{ [key: string]: Contentful.Asset }>({});

    useEffect(() => {
        if (!projects) {
            ContentfulAPI.entries.getList<PortfolioProjectEntry>().then((results) => {
                setProjects(
                    results.items.sort((a, b) => {
                        if (a.fields.date > b.fields.date) return -1;
                        else if (a.fields.date < b.fields.date) return 1;
                        else return 0;
                    }),
                );
                results.includes?.Asset.forEach((asset) => {
                    assets[asset.sys.id] = asset as Contentful.Asset;
                });
            });
        }
    }, [assets, projects]);

    return <ProjectCards projects={projects} assets={assets} />;
}
